import React from "react";

const ZapierBot = () => {
  return (
    <zapier-interfaces-chatbot-embed
        is-popup="true"
        chatbot-id="cmdio9mx8001411glqumb543h">
    </zapier-interfaces-chatbot-embed>
  );
}

export default ZapierBot;